import React, { useState, useEffect } from 'react';
import '../../../css/Preferences/DriverPreference.css';
import { useSelector } from 'react-redux';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { utilityBaseURL } from '../../../Services/config/apiGateway';
import { SERVICE_PREFERENCES } from '../../../Services/config/apiEndPoints';
const DriverPreference = props => {
    const manageProfileDataR = useSelector(state => state.manageProfileReducer.data);
    let [driversData, setDriversData] = useState([]);
    const getPreferences = () => {
        ApiCall(
            'GET',
            utilityBaseURL + SERVICE_PREFERENCES + `?role=${manageProfileDataR?.selectedProfileRoleName}&roleType=Driver`,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((apiData) => {
            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
                    console.log('I am 500!');
                }
                else {
                    console.log('I am 200!');
                    let filteredHaulageData = apiData?.roleType?.filter((name, index) => ['Driver'].includes(name.roleName))
                    setDriversData(filteredHaulageData);
                    console.log('aaa--', filteredHaulageData);
                }
            }
        });
    }
    useEffect(() => {
        getPreferences();
    }, [])
    const renderDriverTableData = driversData?.map((data, index) => {
        return (
            <>
                {(data?.dataList)?.map((d1, i) => {
                    return (
                        <tr key={index} id="driverpreferenceuserdata">
                            <td id="drivercol1" className="drivertabledata">{i + 1}</td>
                            <td id="drivercol2" className="drivertabledata">{d1.companyName}</td>
                        </tr>
                    )
                })}
            </>
        )
    });
    return (
        <div class="csoutercolor">
            <MetaDecorator title={TitleDescription.preferencesTitle} description={TitleDescription.preferencesDescription} />
            <Header tilesFetched={() => { }} />
            <div class="csnofullDriverPref">
                <div id="csnobox1DriverPref">
                    <div className='weathernavbar'>
                        <small id="weathername">Preferences </small>
                    </div><hr className='navbarhr' />
                    <div class="toppartDriverPref">
                        <div class="driverHeadingdiv">
                            <small class="driverHeading">Your Registered Haulage Companies</small>
                        </div>
                        <div class="toppartDriverPrefOuterBox">
                            <div class="topPartDriverMessageSection">
                                <div class="driverMessageValueDiv">
                                    <small class="driverMessageValue">You can add / delete Haulage Company in DTMS</small>
                                </div>
                            </div>
                            <div className="driverTableBoxDiv">
                                <table id='driverPreferenceDetails'>
                                    <tbody>
                                        {renderDriverTableData}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cs2footer11DriverPref">
                <Footer />
            </div>
            <div class="cs2footer22DriverPref">
                <Footer2 />
            </div>
        </div>
    );
};
export default DriverPreference;